module.exports = __webpack_public_path__ + "img/blue-down-arrow.47253e54.svg";